/**
 * AI Assistant MV2 query API — isolated from MV1 pages/AIAssistant.jsx.
 */
import api from "@/lib/api";

export const AI_QUICK_ACTIONS_QUERY_KEY = "ai-quick-actions";

export async function fetchQuickActionsFromApi(signal) {
  const res = await api.get("/ai/quick-actions");
  if (signal?.aborted) throw new DOMException("Aborted", "AbortError");
  if (
    res &&
    res.data &&
    typeof res.data === "object" &&
    !Array.isArray(res.data) &&
    Array.isArray(res.data.actions)
  ) {
    const validActions = res.data.actions.filter((a) => a && a.label && a.prompt);
    return validActions;
  }
  return [];
}
